import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class CodebookService {
  private readonly apiUrl = environment.apiAddress + '/StandardizedTagNameCodebook';

  constructor(private http: HttpClient) {}

  getCodebooks(): Observable<Codebook[]> {
    return this.http.get<Codebook[]>(this.apiUrl);
  }

  createCodebook(codebook: CodebookDetail): Observable<Codebook[]> {
    return this.http.post<Codebook[]>(this.apiUrl, codebook);
  }

  updateCodebook(id: string, codebook: CodebookDetail): Observable<Codebook[]> {
    return this.http.put<Codebook[]>(`${this.apiUrl}/${encodeURIComponent(id)}`, codebook);
  }

  deleteCodebook(id: string): Observable<Codebook[]> {
    return this.http.delete<Codebook[]>(`${this.apiUrl}/${encodeURIComponent(id)}`);
  }
}

export interface Codebook {
  id: string;
  lastUpdatedAt: string;
  deletedUtcDateTime: string | null;
  name: string;
  codebook: CodebookDetail;
}

export interface CodebookDetail {
  name: string;
  revision: number;
  description: string;
  namingLevels: NamingLevel[];
}

export interface NamingLevel {
  levelNumber: number;
  name: string;
  description: string;
  canBeOmitted: boolean;
  validationRule: ValidationRule;
}

export interface ValidationRule {
  validationType: string;
  regex: string;
  allowedValues: AllowedValue[];
  description: string;
}

export interface AllowedValue {
  value: string;
  description: string;
}
